// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-14fd637e] canvas{height:auto!important;background:#fff}", ""]);
// Exports
module.exports = exports;
